<script setup>
import { ref } from "vue";
import { storeToRefs } from "pinia";
import router from "@/router";
import Button from "primevue/button";
import Menu from "primevue/menu";
import Dialog from "primevue/dialog";
import InputText from "primevue/inputtext";
import { salvarAvaliacao } from "@/api/fetchAvaliacoes";
import { useRecursosDidaticosStore } from "@/store/recursosDidaticosStore";
const store = useRecursosDidaticosStore();
const { user, avaliacao, avaliacoes, tabAtiva } = storeToRefs(store);
const menu = ref();
const items = ref([
    {
        label: 'Criar Questões',
        icon: 'pi pi-question-circle',
        command: () => router.push('/professor/criar-questoes')
    },
    {
        label: 'Criar Avaliação',
        icon: 'pi pi-list-check',
        command: () => {visible.value = true}
    }
]);

const tituloAvaliacao = ref('');
const visible = ref(false);
const toggle = (event) => {
    menu.value.toggle(event);
};
const salvandoAvaliacao = ref(false);
const erroSalvarAvaliacao = ref(false);

const salvar = async ()  => {
    salvandoAvaliacao.value = true
    let data = await salvarAvaliacao(user.value.disciplina, user.value.idU, tituloAvaliacao.value);
    if(data.error){
        console.log(data.error);
        return
    }
    avaliacoes.value.push(data.data);
    avaliacao.value.id = data.data.id;
    avaliacao.value.titulo = data.data.titulo;
    avaliacao.value.proprietario = data.data.proprietario;
    avaliacao.value.adicionarQuestoes = true

    console.log(avaliacao.value)
    
    visible.value = false;
    erroSalvarAvaliacao.value = false
    tabAtiva.value = 0
    salvandoAvaliacao.value = false

}
</script>


<template>
    <div class="card flex justify-content-center">
        <Button type="button" icon="pi pi-plus" severity="secondary" text @click="toggle" aria-haspopup="true"
            aria-controls="overlay_menu" label="Criar Recurso"/>
        <Menu ref="menu" id="overlay_menu" :model="items" :popup="true" />
        <Dialog v-model:visible="visible" modal header="Criar Avaliação" :style="{ width: '30rem' }" >
            <InputText v-model="tituloAvaliacao" placeholder="Título da avaliação" class="w-full mt-1 mb-2"  />
            <div class="text-sm text-red-500" v-if="erroSalvarAvaliacao">Ocorreu um erro ao salvar a avaliação. Recarregue a página e tente mais uma vez.</div>
            <Button label="Adicionar Questoes" icon="pi pi-plus" class="w-full mt-3" @click="salvar" :disabled="!tituloAvaliacao" :loading="salvandoAvaliacao" />
        </Dialog>
    </div>
</template>

